import {
    REQUEST_SERVICE_ROUTE,
    REQUEST_SERVICE_ROUTE_FAILURE,
    REQUEST_SERVICE_ROUTE_SUCCESS
} from "../../../constant/transaction/ShipmentConstant";


const initialState = {
    serviceRoute: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const serviceRouteReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_SERVICE_ROUTE:
            return {
                ...state,
                serviceRoute: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_SERVICE_ROUTE_SUCCESS:
            return {
                ...state,
                serviceRoute: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_SERVICE_ROUTE_FAILURE:
            return {
                ...state,
                serviceRoute: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
